import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import makeRequest from 'utils/makeRequest';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Card from 'components_v2/common/CardV7/Card';
import { rodate } from 'utils/common';
import Link from '../../../components/Link';
import s from './InlineCardSlider.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class InlineCardSlider extends React.Component {
  constructor() {
    super();
    this.state = {
      csrData: undefined,
    };
  }

  handleVideoClick(item, index) {
    const {
      gaAction,
      gaCategory,
      fromEtimesAS,
      fromEtimesPS,
      ga4Type,
    } = this.props;
    const { gaLabel } = this.props;

    if (fromEtimesPS) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'photostories_widget',
        category: 'story_click',
        story_no: index + 1,
      });
    }
    if (gaAction && gaCategory && gaLabel) {
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction,
          gaLabel: `${gaLabel}-${index}`,
        },
      });
    } else if (gaAction && !(gaCategory && gaLabel)) {
      if (fromEtimesAS) {
        sendGaThroughProps({
          data: {
            gaAction,
            gaLabel: `${index}-${item.wu}`,
          },
        });
      } else {
        sendGaThroughProps({
          data: {
            gaAction: `${gaAction}-${index}`,
            gaLabel: `${item.wu}`,
          },
        });
      }
    }
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        category: 'story_click',
        label: item?.hl,
        story_no: `${index + 1}`,
        msid: item?.id,
      });
    }
  }

  loadData = () => {
    const { sectionData } = this.props;
    if (sectionData && sectionData.dataUrl) {
      makeRequest
        .get(sectionData.dataUrl)
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            Array.isArray(response.data.items)
          ) {
            this.setState({
              csrData: response.data.items,
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  // Ga4 widget view call
  ga4ViewElement = (ga4Type, ga4Category) => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${ga4Type}`,
        category: `${ga4Category || ''}`,
      });
    }
  };

  render() {
    const {
      sectionData,
      wrapperClass,
      isClientSide,
      borderTop,
      borderBottom,
      ga4Type,
      ga4Category,
      layout,
      cardSpan,
      cardType,
      isCarousel,
      isInsert,
    } = this.props;
    const data =
      (sectionData && (sectionData.data || sectionData.items)) ||
      this.state.csrData;

    const parentClassName = classNames({
      [s.border_top]: borderTop,
      [s.border_bottom]: borderBottom,
      [s.wdt_container]: true,
      [s.insert_scroll]: isCarousel && layout === 'horizontal' && isInsert,
    });

    const cardsListWrapperClass = classNames({
      [s.scroll]: isCarousel,
      crs: isCarousel,
      [s[`${`${layout}_${cardSpan}`}`]]: layout === 'horizontal',
    });

    const component =
      data && data instanceof Array ? (
        <div
          className={`${
            wrapperClass ? s[wrapperClass] : ''
          }  ${parentClassName}`}
        >
          {sectionData.name && (
            <div className={s.heading}>
              {sectionData.path ? (
                <Link to={sectionData.path}>{sectionData.name}</Link>
              ) : (
                <>{sectionData.name}</>
              )}
            </div>
          )}

          <div
            className={`m_1 ${
              layout === 'horizontal' ? s.horizontal_slider : ''
            } ${cardsListWrapperClass} ${
              !isInsert ? 'right_spacing' : ''
            } left_spacing`}
          >
            {data.map((cardItem, index) => (
              <div className={s.card_wrapper} key={cardItem.id}>
                <Card
                  data={{
                    ...cardItem,
                    lpt: cardItem && cardItem.lpt ? rodate(cardItem.lpt) : '',
                  }}
                  onClick={() => {
                    this.handleVideoClick(cardItem, index);
                  }}
                  layout={cardType}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null;

    // if (this.props.border && this.props.border === 'top' && component) {
    //   component = <div className={`${s.border_top}`}>{component}</div>;
    // }
    // if (this.props.border && this.props.border === 'bottom' && component) {
    //   component = <div className={`${s.border_bottom}`}>{component}</div>;
    // }

    return isClientSide ? (
      <InViewObserver
        inViewCallback={() => {
          this.loadData();
          this.ga4ViewElement(ga4Type, ga4Category);
        }}
        viewMargin="900px 0px 900px 0px"
        id={sectionData && sectionData.jumplinkId}
      >
        {component}
      </InViewObserver>
    ) : (
      <InViewObserver
        inViewCallback={() => {
          this.ga4ViewElement(ga4Type, ga4Category);
        }}
        id={sectionData && sectionData.jumplinkId}
      >
        {component}
      </InViewObserver>
    );
  }
}
InlineCardSlider.propTypes = {
  sectionData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    data: PropTypes.shape({}),
    items: PropTypes.shape({}),
    dataUrl: PropTypes.string,
    className: PropTypes.string,
    tn: PropTypes.string,
  }).isRequired,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  gaCategory: PropTypes.string,
  wrapperClass: PropTypes.string,
  isClientSide: PropTypes.bool,
  fromEtimesAS: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
  layout: PropTypes.string,
  cardSpan: PropTypes.number,
  cardType: PropTypes.string,
  isCarousel: PropTypes.bool,
  isInsert: PropTypes.bool,
  borderTop: PropTypes.bool,
  borderBottom: PropTypes.bool,
};
InlineCardSlider.defaultProps = {
  wrapperClass: '',
  gaAction: '',
  gaLabel: undefined,
  gaCategory: undefined,
  isClientSide: false,
  fromEtimesAS: false,
  ga4Type: '',
  ga4Category: '',
  layout: 'horizontal',
  cardSpan: 9,
  cardType: 'card_21',
  isCarousel: true,
  isInsert: false,
  borderTop: false,
  borderBottom: false,
};

export default InlineCardSlider;
